import type { CacheStorageOptions } from '@/shared/lib/hooks/use-cache-storage';
import { CITypesApi } from '@/entities/srm/ci';
import { CIType, CITypeListItem } from '@/entities/srm/ci';
import { Tree } from '@/shared/lib/utils/tree/types';
import { treeMap } from '@/shared/lib/utils/tree/tree-map';
import { pick } from 'lodash';

export const ciTypesListQueryConfig: CacheStorageOptions<CITypeListItem[]> = {
  meta: { cacheStorageEvent: 'CIT' },
  queryKey: ['ci-type-list'],
  queryFn: ({ signal }) =>
    CITypesApi.getCITypeList({ signal, timeout: 15000 }).then((res) =>
      (Array.isArray(res?.data) ? res.data : ([] as CITypeListItem[])).map(
        (x) =>
          pick(x, [
            'id',
            'name',
            'label',
            'color',
            'icon',
            'icon_size',
            'parent_id',
          ]),
      ),
    ),
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  cacheTime: Infinity,
  // staleTime: Infinity,
};

export const ciTypesTreeQueryConfig: CacheStorageOptions<Tree<CIType>> = {
  meta: { cacheStorageEvent: 'CIT' },
  queryKey: ['ci-type-tree'],
  queryFn: ({ signal }) =>
    CITypesApi.getCITypeTree({ signal, timeout: 15000 }).then((res) =>
      treeMap(
        Array.isArray(res?.data) ? res.data : ([] as Tree<CIType>),
        'children',
        (x) => pick(x, ['id', 'name', 'label', 'color', 'icon', 'icon_size']),
      ),
    ),
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  cacheTime: Infinity,
};